var _a;
import { BiEventType } from './constants';
// these are common for all events, you can omit them as they will be automatically mixed in
var commonFields = [
    'evid',
    'client_id',
    'platform',
    'referer',
    'requestid',
    'uuid',
    'url',
    'version',
];
var eventRegistry = (_a = {},
    _a[BiEventType.CLICK_REPORT_BUTTON] = {
        requiredFields: ['deviationid'],
        optionalFields: ['modal_version'],
    },
    _a[BiEventType.BACK_TO_TOP] = {
        requiredFields: ['view'],
        optionalFields: ['attribution', 'component', 'itemid', 'typeid', 'offset'],
    },
    _a[BiEventType.SCROLL_TO_LOAD_MORE] = {
        requiredFields: ['view'],
        optionalFields: ['attribution', 'component', 'itemid', 'typeid', 'offset'],
    },
    _a[BiEventType.PAGEVIEW] = {
        requiredFields: ['view'],
        optionalFields: [
            'component',
            'feed_mode',
            'is_duper',
            'itemid',
            'typeid',
            'view_mode',
        ],
    },
    _a[BiEventType.THUMB_CLICK] = {
        requiredFields: ['view', 'itemid', 'typeid', 'creatorid'],
        optionalFields: [
            'attribution',
            'component',
            'sectionid',
            'sectionname',
            'section_typeid',
            'widgetname',
            'rank',
        ],
    },
    _a[BiEventType.USERNAME_CLICK] = {
        requiredFields: ['view', 'itemid', 'typeid', 'creatorid'],
        optionalFields: [
            'attribution',
            'component',
            'sectionid',
            'sectionname',
            'section_typeid',
            'widgetname',
            'rank',
        ],
    },
    _a[BiEventType.THUMB_FAVE] = {
        requiredFields: ['view', 'itemid', 'typeid', 'creatorid'],
        optionalFields: [
            'attribution',
            'component',
            'sectionid',
            'sectionname',
            'section_typeid',
            'widgetname',
            'rank',
        ],
    },
    _a[BiEventType.THUMB_CLICK_LOVE_METER] = {
        requiredFields: ['view', 'typeid', 'itemid', 'creatorid'],
        optionalFields: [
            'attribution',
            'component',
            'sectionid',
            'sectionname',
            'section_typeid',
        ],
    },
    _a[BiEventType.THUMB_SELECT_LOVE] = {
        requiredFields: ['view', 'typeid', 'itemid', 'creatorid', 'love'],
        optionalFields: [
            'attribution',
            'component',
            'sectionid',
            'sectionname',
            'section_typeid',
            'widgetname',
        ],
    },
    _a[BiEventType.THUMB_CLICK_COMMENT] = {
        requiredFields: ['view', 'typeid', 'itemid', 'creatorid'],
        optionalFields: [
            'attribution',
            'component',
            'sectionid',
            'sectionname',
            'section_typeid',
            'widgetname',
            'rank',
        ],
    },
    _a[BiEventType.SEE_ALL_CLICK] = {
        requiredFields: ['view'],
        optionalFields: [
            'attribution',
            'component',
            'creatorid',
            'itemid',
            'sectionid',
            'sectionname',
            'section_typeid',
            'typeid',
            'widgetname',
        ],
    },
    _a[BiEventType.USERNAME_HOVER_TO_OPEN] = {
        requiredFields: ['view'],
        optionalFields: [
            'attribution',
            'component',
            'creatorid',
            'itemid',
            'sectionid',
            'sectionname',
            'section_typeid',
            'typeid',
            'widgetname',
            'rank',
        ],
    },
    _a[BiEventType.CAROUSEL_ARROW_CLICK] = {
        requiredFields: ['view'],
        optionalFields: [
            'component',
            'typeid',
            'itemid',
            'direction',
            'scroll_pct',
            'sectionname',
            'widgetname',
        ],
    },
    _a[BiEventType.CONTENT_NAVBAR_CLICK] = {
        requiredFields: ['view', 'link_name'],
        optionalFields: ['component'],
    },
    _a[BiEventType.SORT_TYPE_SELECT] = {
        requiredFields: ['view', 'sort_selection'],
        optionalFields: ['component'],
    },
    _a[BiEventType.FACET_CONTROL_TOGGLE] = {
        requiredFields: ['view', 'facet_toggle'],
        optionalFields: ['component'],
    },
    _a[BiEventType.FACET_SELECT] = {
        requiredFields: ['view', 'facetitem', 'facetname'],
        optionalFields: ['component'],
    },
    _a[BiEventType.PROFILE_NAV_BAR] = {
        requiredFields: ['view', 'link_name'],
        optionalFields: ['component'],
    },
    _a[BiEventType.SEND_NOTE_CLICK] = {
        requiredFields: ['view', 'recipientid', 'sectionname'],
        optionalFields: ['component', 'typeid', 'itemid', 'rank'],
    },
    _a[BiEventType.GIFT_CLICK] = {
        requiredFields: ['view', 'recipientid'],
        optionalFields: ['component'],
    },
    _a[BiEventType.GIFT_SELECT_CLICK] = {
        requiredFields: ['view', 'recipientid', 'menu_item_name'],
        optionalFields: ['component', 'link_url'],
    },
    _a[BiEventType.NAVIGATION_ARROW_CLICK] = {
        requiredFields: ['view', 'itemid', 'typeid', 'next_itemid', 'direction'],
        optionalFields: ['component', 'galleryid'],
    },
    _a[BiEventType.THEATRE_MODE] = {
        requiredFields: ['view', 'deviationid', 'viewmode'],
        optionalFields: ['component'],
    },
    _a[BiEventType.FULLSCREEN_MODE] = {
        requiredFields: ['view', 'deviationid', 'viewmode'],
        optionalFields: ['component'],
    },
    _a[BiEventType.ZOOM_MODE] = {
        requiredFields: ['view', 'deviationid', 'viewmode'],
        optionalFields: ['component'],
    },
    _a[BiEventType.BACK_TO_CLICK] = {
        requiredFields: ['view', 'itemid', 'typeid', 'link_url'],
        optionalFields: ['component', 'next_itemid', 'next_typeid'],
    },
    _a[BiEventType.CLICK_DOWNLOAD_BUTTON] = {
        requiredFields: ['view', 'deviationid', 'ispaiddownload'],
        optionalFields: ['component'],
    },
    _a[BiEventType.DOWNLOAD_NOW_CLICK] = {
        requiredFields: ['view', 'deviationid'],
        optionalFields: ['component'],
    },
    _a[BiEventType.ADD_TO_COLLECTION_CLICK] = {
        requiredFields: ['view', 'component', 'creatorid', 'typeid', 'itemid'],
        optionalFields: ['sectionname'],
    },
    _a[BiEventType.ADD_TO_COLLECTION_DONE_CLICK] = {
        requiredFields: [
            'view',
            'component',
            'creatorid',
            'typeid',
            'itemid',
            'num_collections',
        ],
        optionalFields: ['sectionname', 'collectionid'],
    },
    _a[BiEventType.CLICK_SHARE] = {
        requiredFields: ['view', 'itemid', 'typeid'],
        optionalFields: ['component', 'deviationid'],
    },
    _a[BiEventType.CLICK_SOCIAL_SHARE] = {
        requiredFields: ['view', 'social_share', 'itemid', 'typeid'],
        optionalFields: ['component', 'deviationid'],
    },
    _a[BiEventType.CLICK_COPY] = {
        requiredFields: ['view', 'itemid', 'typeid'],
        optionalFields: ['component', 'deviationid'],
    },
    _a[BiEventType.BUY_CLICK] = {
        requiredFields: ['view', 'deviationid'],
        optionalFields: ['component'],
    },
    _a[BiEventType.FACET_CLICK] = {
        requiredFields: ['view', 'component', 'link_url', 'facetname', 'facetitem'],
        optionalFields: [],
    },
    _a[BiEventType.TAG_CLICK] = {
        requiredFields: ['view', 'tag_text', 'link_url'],
        optionalFields: ['component', 'tagid'],
    },
    _a[BiEventType.WATCH_SECTION_SELECT] = {
        requiredFields: ['view'],
        optionalFields: ['component', 'sectionname', 'is_from_navbar'],
    },
    _a[BiEventType.TOP_NAV_CLICK] = {
        requiredFields: ['view'],
        optionalFields: ['component', 'link_name', 'link_url', 'indicator'],
    },
    _a[BiEventType.TOP_NAV_MENU_CLICK] = {
        requiredFields: ['view'],
        optionalFields: [
            'component',
            'link_url',
            'menu_item',
            'menu_name',
            'toggle_value',
        ],
    },
    _a[BiEventType.CLOSE_BANNER_AD] = {
        requiredFields: ['view', 'campaignid', 'realestateid'],
        optionalFields: ['component'],
    },
    _a[BiEventType.WATCH_AUTHOR] = {
        requiredFields: ['view', 'friendid', 'is_watching'],
        optionalFields: ['component', 'itemid', 'sectionname', 'typeid', 'rank'],
    },
    _a[BiEventType.VIEW_MODE_SELECT] = {
        requiredFields: ['view', 'link_name'],
        optionalFields: ['component'],
    },
    _a);
export default function getFieldsForEvent(evid) {
    var registry = eventRegistry[evid];
    if (!registry) {
        return;
    }
    return {
        optionalFields: (registry.optionalFields || []).slice(),
        requiredFields: (registry.requiredFields || []).concat(commonFields),
    };
}
//# sourceMappingURL=eventRegistry.js.map